<template>
  <Component v-if="currentComponent" :is="currentComponent" />
</template>
<script>
import { mapGetters } from 'vuex';
import { Lang } from '@/utils/index.model';
import JackpotPhysicalPrizeEn from '@/components/jackpot/jackpot-physical-prize/en';
import JackpotPhysicalPrizeVn from '@/components/jackpot/jackpot-physical-prize/vn';

export default {
  computed: {
    ...mapGetters({
      config: 'general/config',
    }),
    currentComponent() {
      switch (this.config.language) {
        case Lang.vn:
          return JackpotPhysicalPrizeVn;
        default:
          return JackpotPhysicalPrizeEn;
      }
    },
  },
};
</script>
